import Container = Phaser.GameObjects.Container;
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import Image = Phaser.GameObjects.Image;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import Text = Phaser.GameObjects.Text;
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class PlayerActionButton extends Container {

    private readonly DEPTH: number = 1000;
    private onClickCallback!: () => unknown;
    private buttonIcon!: Image;
    private buttonText!: Text;

    constructor(scene: Scene, x: number, y: number, text: string, atlas: string | undefined, icon: string, textWidth: number, onClickCallback: () => unknown) {
        super(scene);

        this.setDepth(this.DEPTH);

        this.onClickCallback = onClickCallback;

        if (atlas) {
            this.buttonIcon = SpriteUtils.addImage(this.scene, x, y, atlas, icon);
        } else {
            this.buttonIcon = SpriteUtils.addImage(this.scene, x, y, icon);
        }
        SpriteUtils.scale(this.buttonIcon, 0.7).setOrigin(0.5, 1);

        let soundButtonBack = SpriteUtils.addImage(this.scene, this.buttonIcon.x / CU.S, this.buttonIcon.y / CU.S - 20, Keys.ATLAS_UI, Keys.UI_BADGE_LINER);
        SpriteUtils.setDispSize(soundButtonBack, 80, 80);

        this.buttonText = TextUtils.addTextAdvanced(this.scene, text, this.buttonIcon.x / CU.S, this.buttonIcon.y  / CU.S + 7,
            '#cac8c3', 10, 'normal', textWidth, 'center', 2, Fonts.BENGALY_NORMAL)
            .setOrigin(0.5, 0);

        this.buttonIcon.setInteractive().on('pointerup', () => {
            if (this.onClickCallback != null) {
                this.onClickCallback();
            }
        });

        this.buttonText.setInteractive().on('pointerup', () => {
            if (this.onClickCallback != null) {
                this.onClickCallback();
            }
        });

        this.add([soundButtonBack, this.buttonIcon, this.buttonText]);
    }

    public setButtonAlpha(value: number) {
        this.buttonIcon.setAlpha(value);
    }

    public setButtonImage(atlas: string | undefined, key: string) {
        if (atlas) {
            SpriteUtils.setSprite(this.scene, this.buttonIcon, atlas, key);
        } else {
            SpriteUtils.setSprite(this.scene, this.buttonIcon, key);
        }
    }

    public setButtonText(text: string) {
        this.buttonText.setText(text);
    }

}
